import { render, staticRenderFns } from "./OsSurveyStepIntroLanguage.vue?vue&type=template&id=2f7a1b52&scoped=true"
import script from "./OsSurveyStepIntroLanguage.vue?vue&type=script&lang=ts"
export * from "./OsSurveyStepIntroLanguage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7a1b52",
  null
  
)

export default component.exports